import { endOfDay, isValid, startOfDay } from "date-fns";

export const getFilterDateRange = (
  fromDate: Date | null,
  toDate: Date | null
) => {
  const after_date =
    fromDate && (isValid(fromDate) ? startOfDay(fromDate) : null);
  const before_date = toDate && (isValid(toDate) ? endOfDay(toDate) : null);

  return {
    after_date,
    before_date,
    after_date_iso: after_date?.toISOString() || null,
    before_date_iso: before_date?.toISOString() || null,
  };
};
